import { Flex } from 'antd'
import React from 'react'

import { Button } from '@suntex.fim/ui'

import type { ColorPickerProps } from '../../types/avatar'

const ColorPicker: React.FC<ColorPickerProps> = ({
  colors,
  selectedColor,
  onColorSelect
}) => {
  return (
    <Flex
      gap={24}
      vertical
      justify="center"
      align="center"
      className="avatar-rightbox__colorpicker"
    >
      <p className="fw-bold">
        Choose a color & icon to create a custom Player Avatar
      </p>
      <div className="avatar-rightbox__colorpicker-wrapper">
        {colors.map((color, index) => (
          // eslint-disable-next-line react/forbid-elements
          <button
            key={`color-${index}`}
            type="button"
            onClick={() => onColorSelect(color)}
            className="avatar-rightbox__colorpicker-btn"
            style={{
              backgroundColor: color,
              border:
                selectedColor === color ? '4px solid #333' : '2px solid #ddd',
              transition: 'all 0.2s ease'
            }}
            title={`Select color ${color}`}
            aria-label={`Select color ${color}`}
          />
        ))}
      </div>
    </Flex>
  )
}

export default ColorPicker
